export function TriggerTypeIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99718 11.4178C1.85521 11.4178 1.73249 11.2958 1.73249 11.1358V2.23746C1.73249 2.07745 1.85521 1.95269 1.99718 1.95269H9.89204C10.034 1.95269 10.1543 2.07745 10.1543 2.23746V7.72941H11.8868V2.23746C11.8868 0.998043 10.9917 0 9.89204 0H1.99718C0.897527 0 0 0.998043 0 2.23746V11.1358C0 12.3752 0.897527 13.3705 1.99718 13.3705H3.68154V11.4178H1.99718Z"
        fill={color}
      />
      <path
        d="M14.0077 5.80273H12.2704V7.75543H14.0077C14.1497 7.75543 14.2676 7.88018 14.2676 8.0402V16.9385C14.2676 17.0985 14.1497 17.2477 14.0077 17.2477H6.11286C5.9709 17.2477 5.84577 17.0985 5.84577 16.9385V11.4438H4.11328V16.9385C4.11328 18.1779 5.01321 19.2004 6.11286 19.2004H14.0077C15.1074 19.2004 16.0001 18.1779 16.0001 16.9385V8.0402C16.0001 6.80078 15.1074 5.80273 14.0077 5.80273Z"
        fill={color}
      />
      <path
        d="M10.2662 13.3187C10.0448 13.3187 9.8234 13.2237 9.65256 13.0339L4.85212 7.6233C4.51284 7.2409 4.51284 6.62255 4.85212 6.24286C5.1914 5.86045 5.74002 5.86045 6.07689 6.24286L10.8773 11.6507C11.2166 12.0331 11.2166 12.6515 10.8773 13.0312C10.7089 13.2237 10.4875 13.3187 10.2662 13.3187Z"
        fill={color}
      />
    </svg>
  );
}
